import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetExternalContacts = async (params) => axios.get(apiPaths.externalContactsBase, { params });

const onCreateExternalContact = async (payload) => axios.post(apiPaths.externalContactsBase, [payload]);
const onUpdateExternalContact = async (payload) => axios.put(apiPaths.externalContactsBase, [payload]);
const onDeleteExternalContact = async (payload) =>
  axios.post(`${apiPaths.externalContactsBase}/delete-many`, [payload]);

export { onGetExternalContacts, onCreateExternalContact, onUpdateExternalContact, onDeleteExternalContact };
